<template lang="">
    <b-container>
        <b-row class="card shadow">
            <div class="my-2 row search-prospect mx-0 justify-content-end mr-3">
                <div class="border d-flex align-items-center col-8 col-md-4 rounded-3">
                    <i class="fa fa-search mt-1" aria-hidden="true"></i>
                    <input type="text" class="border-0 h-100 w-100" placeholder="rechercher...">
                </div>
                <div class="border col col-md-2 rounded-3">
                    <select name="" id="" class="h-100 w-100 border-0 py-2">
                        <option value="">15</option>
                        <option value="">25</option>
                        <option value="">50</option>
                        <option value="">100</option>
                    </select>
                </div>
            </div>
            <b-row class="souscripteur d-none d-md-block container-fluid">
                    <ul class="souscripteur_thead row w-100">
                            <li class="col text-left">Nom</li>
                            <li class="col text-left">Prenom</li>
                            <li class="col text-center">Télèphone</li>
                            <li class="col text-center">Produit</li>
                            <li class="col text-center">Action</li>
                        </ul>
                    <div v-for="(cmd,index) in commandes_attentes" :key="index">
                        <ul class="souscripteur_tbody row py-2" v-if="cmd.souscripteur!= null">
                                <li class="col-2 text-left">{{cmd.souscripteur.nom }}</li>
                                <li class="col text-center">{{cmd.souscripteur.email }}</li>
                                <li class="col text-center">{{cmd.souscripteur.telephone }}</li>
                                <li class="col text-center">{{ cmd.commande.description_fr | truncate(10) }}</li>
                             
                                <li class="btn-toggle col text-center">
                                    <b-dropdown
                                        text="action"
                                        variant="primary"
                                        
                                        class=""
                                        size="sm"
                                    >
                                            <b-dropdown-item
                                                    href="#"
                                                    v-if=""
                                                    @click="showPayer(cmd)"
                                                   
                                                >Payer
                                            </b-dropdown-item>
                                           
                                            <b-dropdown-item
                                                    href="#"
                                                    
                                                    @click="showAnnuler(cmd)"
                                                    
                                                >
                                                Refuser
                                            </b-dropdown-item>
                                    </b-dropdown>
                                    
                                </li>
                            </ul>
                        <div>
                     </div>
                  
                </div>
                    
                <!--Modal pour payé  -->
                <b-modal id="modal-payer" hide-footer centered title="Information propect">
                    <div v-if="editing_commande.souscripteur!= null">
                    <ul class="prospect-info p-0">
                        <li class="d-flex justify-content-between">
                            <p class="prospect-title">Nom</p>
                            <p class="">{{editing_commande.souscripteur.nom}} {{editing_commande.souscripteur.prenom}}</p>
                        </li>
                        <li class="d-flex justify-content-between py-3">
                            <p class="prospect-title">Pays</p>
                            <p class="">{{editing_commande.souscripteur.pays}}</p>
                        </li>
                        <li class="d-flex justify-content-between py-3">
                            <p class="prospect-title">Télèphone</p>
                            <p class="">{{editing_commande.souscripteur.telephone}}</p>
                        </li>
                        <li class="d-flex justify-content-between py-3">
                            <p class="prospect-title">Email</p>
                            <p class="">{{editing_commande.souscripteur.email}}</p>
                        </li>
                        <li class="d-flex justify-content-between py-3">
                            <p class="prospect-title">Produit</p>
                            <p class="">{{editing_commande.commande.description_fr}}</p>
                        </li>
                        <li class="d-flex justify-content-between py-3">
                            <p class="prospect-title">Date de paiement</p>
                            <p class="">{{editing_commande.date_payment}}</p>
                        </li>
                        
                        <li class="d-flex justify-content-between py-3">
                                <p class="prospect-title">Prix unitaire</p>
                                <p class="">{{editing_commande.commande.prix_unitaire}}</p>
                            </li>
                        <li class="d-flex justify-content-between py-3">
                            <p class="prospect-title">Quantité</p>
                            <p class="">{{editing_commande.commande.quantite}}</p>
                        </li>
                        <li class="d-flex justify-content-between py-3">
                            <p class="prospect-title">Montant totale</p>
                            <p class="">{{editing_commande.montant}}</p>
                        </li>
                    </ul>
                    <li class=" d-flex justify-content-between">
                        <p class="prospect-title">Cliquez sur cette icon pour confirmer la demande</p>
                        <p class="prospect-payer align-items-center border">
                            <i class="fa fa-credit-card" aria-hidden="true"></i>
                        </p>
                    </li>
                    </div>
                </b-modal>

                <!-- Modal pour Supprimé -->
                <b-modal id="modal-Annuler" hide-footer centered title="Information propect">
                    <div v-if="editing_commande.souscripteur!= null">
                        <ul class="prospect-info p-0">
                            <li class="d-flex justify-content-between">
                                <p class="prospect-title">Nom</p>
                                <p class="">{{editing_commande.souscripteur.nom}} {{editing_commande.souscripteur.prenom}}</p>
                            </li>
                            <li class="d-flex justify-content-between py-3">
                                <p class="prospect-title">Pays</p>
                                <p class="">{{editing_commande.souscripteur.pays}}</p>
                            </li>
                            <li class="d-flex justify-content-between py-3">
                                <p class="prospect-title">Télèphone</p>
                                <p class="">{{editing_commande.souscripteur.telephone}}</p>
                            </li>
                            <li class="d-flex justify-content-between py-3">
                                <p class="prospect-title">Email</p>
                                <p class="">{{editing_commande.souscripteur.email}}</p>
                            </li>
                            <li class="d-flex justify-content-between py-3">
                                <p class="prospect-title">Produit</p>
                                <p class="">{{editing_commande.commande.description_fr}}</p>
                            </li>
                            <li class="d-flex justify-content-between py-3">
                                <p class="prospect-title">Date de paiement</p>
                                <p class="">{{editing_commande.date_payment}}</p>
                            </li>
                            
                            <li class="d-flex justify-content-between py-3">
                                <p class="prospect-title">Prix unitaire</p>
                                <p class="">{{editing_commande.commande.prix_unitaire}}</p>
                            </li>
                            <li class="d-flex justify-content-between py-3">
                                <p class="prospect-title">Quantité</p>
                                <p class="">{{editing_commande.commande.quantite}}</p>
                            </li>
                            <li class="d-flex justify-content-between py-3">
                                <p class="prospect-title">Montant</p>
                                <p class="">{{editing_commande.montant}}</p>
                            </li>
                        </ul>
                        <li class=" d-flex justify-content-between">
                        <p class="prospect-title">Cliquez sur cette icon pour supprimer la demande</p>
                        <p class="prospect-delete align-items-center border">
                            <i class="fa fa-trash ml-2" aria-hidden="true"></i>
                        </p>
                    </li>
                    </div>
                  
                </b-modal>
            <!-- Modal pour Voir -->

            <b-modal id="modal-center" hide-footer centered title="Information propect">
                    <ul class="prospect-info p-0">
                        <li class="d-flex justify-content-between">
                            <p class="prospect-title">Nom</p>
                            <p class="">David Pouani Tinto</p>
                        </li>
                        <li class="d-flex justify-content-between py-3">
                            <p class="prospect-title">Prenom</p>
                            <p class="">Test Tinti Ulrich</p>
                        </li>
                        <li class="d-flex justify-content-between py-3">
                            <p class="prospect-title">Pays</p>
                            <p class="">Cameroun</p>
                        </li>
                        <li class="d-flex justify-content-between py-3">
                            <p class="prospect-title">Télèphone</p>
                            <p class="">+237 656789636</p>
                        </li>
                        <li class="d-flex justify-content-between py-3">
                            <p class="prospect-title">Email</p>
                            <p class="">david@gmail.com</p>
                        </li>
                        <li class="d-flex justify-content-between py-3">
                            <p class="prospect-title">Produit</p>
                            <p class="">{{text}}</p>
                        </li>
                        <li class="d-flex justify-content-between py-3">
                            <p class="prospect-title">Quantité</p>
                            <p class="">6</p>
                        </li>
                        <li class="d-flex justify-content-between py-3">
                            <p class="prospect-title">Prix unitaire</p>
                            <p class="">1</p>
                        </li>
                    </ul>
                    <li class=" d-flex justify-content-between">
                        <p class="prospect-title">Cliquez sur cette icon pour supprimer la demande</p>
                        <p class="prospect-delete align-items-center border">
                            <i class="fa fa-trash ml-2" aria-hidden="true"></i>
                        </p>
                    </li>
                </b-modal>

            </b-row>
            <b-col class="justify-content-center d-block d-md-none">
                
                <div v-for="(cmd,index) in commandes_attentes" :key="index">
                        <ul class="prospect-info p-0" v-if="cmd.souscripteur!= null">
                            <li class="d-flex justify-content-between py-3">
                                <p class="prospect-title">Nom</p>
                                <p class="">{{cmd.souscripteur.nom}} {{cmd.souscripteur.prenom}}</p>
                            </li>
                            <li class="d-flex justify-content-between py-3">
                                <p class="prospect-title">Pays</p>
                                <p class="">{{cmd.souscripteur.pays}}</p>
                            </li>
                            <li class="d-flex justify-content-between py-3">
                                <p class="prospect-title">Télèphone</p>
                                <p class="">{{cmd.souscripteur.telephone}}</p>
                            </li>
                            <li class="d-flex justify-content-between py-3">
                                <p class="prospect-title">Email</p>
                                <p class="">{{cmd.souscripteur.email}}</p>
                            </li>
                            <li class="d-flex justify-content-between py-3">
                                <p class="prospect-title">Produit</p>
                                <p class="">{{cmd.commande.description_fr}}</p>
                            </li>
                            <li class="d-flex justify-content-between py-3">
                                <p class="prospect-title">Date de paiement</p>
                                <p class="">{{cmd.date_payment}}</p>
                            </li>
                            
                            <li class="d-flex justify-content-between py-3">
                                <p class="prospect-title">Prix unitaire</p>
                                <p class="">{{cmd.commande.prix_unitaire}}</p>
                            </li>
                            <li class="d-flex justify-content-between py-3">
                                <p class="prospect-title">Quantité</p>
                                <p class="">{{cmd.commande.quantite}}</p>
                            </li>
                            <li class="d-flex justify-content-between py-3">
                                <p class="prospect-title">Montant</p>
                                <p class="">{{cmd.montant}}</p>
                            </li>
                            
                        </ul>
                        <li class=" d-flex justify-content-between">
                        <p class="prospect-title"><b-button size="sm" variant="primary">Payer</b-button></p>
                        <p class="prospect-delete align-items-center border"><b-button size="sm"  variant="danger">
                            <i class="fa fa-trash ml-2" aria-hidden="true"></i> </b-button>
                        </p>
                    </li>
                    <hr>
                </div>
                
                </div>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import { mapGetters } from 'vuex';
import _ from 'lodash';
export default { 
    data() {
        return {
            text: "CIM URGENECE PLUS",
            editing_commande:[],
        }
    },    
    computed: {
        ...mapGetters(['commandes_attentes'])
        },
    filters: {
        truncate(value, length) {
        if (value.length > length) {
            return value.substring(0, length) + "...";
        } else {
            return value;
        }
      }
    },
    methods:{
        showPayer(cmd) {
           this.editing_commande = cmd;
            this.$bvModal.show('modal-payer')
        },
        showAnnuler(cmd) {
           this.editing_commande = cmd;
            this.$bvModal.show('modal-Annuler')
        },
        getCommandesAttentes(){

            let args = {
                offset: this.offset,
                limit: this.limit
            };    
            this.$store.dispatch('getCommandesAttentes', { args : args });
            // console.log(this.commandes_attentes)
        }
    },
    mounted() {
        this.getCommandesAttentes()
    }
}
</script>
<style lang="">
    
</style>